import api from '../../api/api';
import toast from 'react-hot-toast';

export const ACTION_SET_TEMPLATES = 'ACTION_SET_TEMPLATES';
export function setTemplates(userId) {
  return function (dispatch) {
    api.get(`/user/allowedTemplate/${userId}`).then((resp) =>
      dispatch({
        type: ACTION_SET_TEMPLATES,
        payload: resp.data,
      })
    );
  };
}
export const ACTION_SET_CONTRACTS = 'ACTION_SET_CONTRACT';
export function setContract(userId) {
  return function (dispatch) {
    api.get('/contract/user/' + userId).then((resp) =>
      dispatch({
        type: ACTION_SET_CONTRACTS,
        payload: resp.data,
      })
    );
  };
}

export const ACTION_UNSET_CONTRACTS = 'ACTION_UNSET_CONTRACTS';

export const ACTION_CREATE_CONTRACT = 'ACTION_CREATE_CONTRACT';
export function saveContract(dataContract) {
  return function (dispatch) {
    api.post('/contract/new', dataContract).then((resp) =>
      dispatch({
        type: ACTION_CREATE_CONTRACT,
        payload: resp.data,
      })
    );
  };
}
export const ACTION_UPDATE_CONTRACT = 'ACTION_UPDATE_CONTRACT';
export function transContract(contractId, gasUsed) {
  return function (dispatch) {
    api.patch(`/contract/transfer/${contractId}`, { gasUsed }).then((resp) =>
      dispatch({
        type: ACTION_UPDATE_CONTRACT,
        payload: resp.data,
      })
    );
  };
}
export function addContractData(contractId, data) {
  return function (dispatch) {
    api.patch(`/contract/custom/${contractId}`, data).then((resp) =>
      dispatch({
        type: ACTION_UPDATE_CONTRACT,
        payload: resp.data,
      })
    );
  };
}
export function addContractCustomImage(contractId, file) {
  return function (dispatch) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      api
        .patch(`/contract/custom-image/${contractId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((resp) =>
          dispatch({
            type: ACTION_UPDATE_CONTRACT,
            payload: resp.data,
          })
        );
      toast.success('Successfully upload!');
    } catch (error) {
      console.log(error);
      toast.error('Upload failed!');
    }
  };
}
